import template from './message-preview.tpl.html';

class MessagePreviewCtrl {


}

angular
    .module('festzelt-os.components')
    .component('messagePreview', {
        bindings: {
            message: '<',
        },
        controller: ['Alert', '$http', MessagePreviewCtrl],
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/components/components/message-preview/message-preview.js